import type { Structure } from '@wix/thunderbolt-becky-types'
import type { BuilderComponentsHierarchy } from '../builderComponentHierarchy'

export const getBuilderComponentsInStructure = (structure: Structure) => {
	const builderComponentsInStructure = new Set<string>()
	for (const compId in structure) {
		const comp = structure[compId]
		if (comp.builderType) {
			builderComponentsInStructure.add(comp.builderType)
		}
	}
	return builderComponentsInStructure
}

export const getAllBuilderComponentsOnPage = (structure: Structure, compTypeToAllDescendants: BuilderComponentsHierarchy) => {
	const builderComponentsInStructure = getBuilderComponentsInStructure(structure)
	const allBuilderComponentsOnPage = new Set(
		Array.from(builderComponentsInStructure).flatMap((compType) => [
			compType,
			...(compTypeToAllDescendants[compType] || [])
		])
	)
	return allBuilderComponentsOnPage
}
